// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Exit: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 54 57"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M33.1 51.7H4.5V4.5h28.6c.8 0 1.4-.6 1.4-1.4s-.6-1.4-1.4-1.4h-30c-.8 0-1.4.6-1.4 1.4v50c0 .8.6 1.4 1.4 1.4h30c.8 0 1.4-.6 1.4-1.4s-.6-1.4-1.4-1.4z"/><path d="M51.5 26.8l-7-7c-.5-.5-1.4-.5-1.9 0s-.5 1.4 0 1.9l4.6 4.6H23.1c-.8 0-1.4.6-1.4 1.4s.6 1.4 1.4 1.4h24.1l-4.6 4.6c-.5.5-.5 1.4 0 1.9.3.3.6.4 1 .4s.7-.1 1-.4l7-7c.3-.3.4-.6.4-1s-.2-.6-.5-.8z"/></svg>;
};

export default React.memo(Exit);
